import { GeoPoint } from '../../location/types';
import mapboxgl from 'mapbox-gl';
import { useEffect, useRef } from 'react';
import 'mapbox-gl/dist/mapbox-gl.css';
import { useBootstrapState } from '../../bootstrap/bootstrap-provider';

export const useMapboxMap = (mapOptions: {
    mapContainerRef: React.MutableRefObject<HTMLElement | null>;
    centerPoint: GeoPoint;
}) => {
    const { centerPoint, mapContainerRef } = mapOptions;
    const mapRef = useRef<undefined | InstanceType<typeof mapboxgl['Map']>>(undefined);
    const bootstrapState = useBootstrapState();
    if (bootstrapState.mapboxToken) {
        mapboxgl.accessToken = bootstrapState.mapboxToken;
    }

    useEffect(() => {
        if (mapRef.current || !mapContainerRef.current) return;
        mapRef.current = new mapboxgl.Map({
            container: mapContainerRef.current,
            style: 'mapbox://styles/mapbox/dark-v11',
            center: [centerPoint.longitude, centerPoint.latitude],
            zoom: 14,
            minZoom: 0,
            maxZoom: 32,
            attributionControl: false,
        });
        mapRef.current.addControl(
            new mapboxgl.NavigationControl({
                showCompass: false,
                showZoom: true,
                visualizePitch: false,
            })
        );
        mapRef.current.on('render', () => {
            mapRef.current?.resize();
        });
    });
    useEffect(() => {
        return () => {
            mapRef.current?.remove();
        };
    }, []);
    return mapRef;
};
